import { LocationType } from 'generated/index';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import {
  ControlledTextField,
  ControlledToggleButtonGroup
} from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { FieldKey } from '../input-field-grants';

type Props = {
  enable?: boolean;
  control: Control<any>;
  locationType?: LocationType;
  hasFieldGrant: (key: FieldKey) => boolean;
};

const ExtraSection = ({
  enable,
  control,
  locationType,
  hasFieldGrant
}: Props) => {
  const { t } = useTranslation();

  if (!enable) return null;

  return (
    <MultiStepForm.Section title="Extra">
      {hasFieldGrant('DESCRIPTION') && (
        <ControlledTextField
          control={control}
          name="description"
          label={t('remark')}
          variant="outlined"
        />
      )}

      {hasFieldGrant('LOCATION_TYPE') && (
        <Box>
          <ControlledToggleButtonGroup
            control={control}
            name="locationType"
            color="secondary"
            aria-label="alignment"
            inputToggleButtons={[
              {
                label: t('activityPlanning.clientAddress'),
                value: 'CLIENTADDRESS',
                selected: locationType === 'CLIENTADDRESS'
              },
              {
                label: t('activityPlanning.telecare'),
                value: 'TELECARE',
                selected: locationType === 'TELECARE'
              }
            ]}
          />
        </Box>
      )}
    </MultiStepForm.Section>
  );
};

export default ExtraSection;
